var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_612_2498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_612_2498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.32 21.52L22.78 13.06L21.1 11.38L14.32 18.16L10.9 14.74L9.22 16.42L14.32 21.52ZM16 28C14.34 28 12.78 27.6848 11.32 27.0544C9.86 26.4248 8.59 25.57 7.51 24.49C6.43 23.41 5.5752 22.14 4.9456 20.68C4.3152 19.22 4 17.66 4 16C4 14.34 4.3152 12.78 4.9456 11.32C5.5752 9.86 6.43 8.59 7.51 7.51C8.59 6.43 9.86 5.5748 11.32 4.9444C12.78 4.3148 14.34 4 16 4C17.66 4 19.22 4.3148 20.68 4.9444C22.14 5.5748 23.41 6.43 24.49 7.51C25.57 8.59 26.4248 9.86 27.0544 11.32C27.6848 12.78 28 14.34 28 16C28 17.66 27.6848 19.22 27.0544 20.68C26.4248 22.14 25.57 23.41 24.49 24.49C23.41 25.57 22.14 26.4248 20.68 27.0544C19.22 27.6848 17.66 28 16 28Z",
    fill: "#00DF80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastIcon);
export default __webpack_public_path__ + "static/media/toastIcon.0bd3fa60ac1c1a78f251bd84993c8742.svg";
export { ForwardRef as ReactComponent };